(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["custom-admin-sidebar"]) return;
  try {
    
document.addEventListener("DOMContentLoaded",function(){var e=document.querySelector("body");e&&e.classList.add("admin-page")});const adminListContainer=document.querySelector(".admin-list-container"),selectAdminPage=document.querySelector(".select-admin-page");function toggleDropdown(){adminListContainer.classList.toggle("open-list"),selectAdminPage.textContent=adminListContainer.classList.contains("open-list")?"Collapse":"Select page"}selectAdminPage.addEventListener("click",toggleDropdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-brand-banner"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded",function(){setTimeout(function(){var e=document.querySelector(".brand-details-banner");e&&e.classList.add("loaded")},800)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-scroller"] && !window.DesignMode) return;
  try {
    
  const collectionLinks=document.querySelectorAll(".collection-link"),separators=document.querySelectorAll(".separator");collectionLinks.forEach(e=>{e.addEventListener("mouseenter",()=>{collectionLinks.forEach(r=>{r!==e&&r.classList.add("no-hover")}),separators.forEach(e=>{e.classList.add("no-hover")}),e.classList.add("hover")}),e.addEventListener("mouseleave",()=>{collectionLinks.forEach(r=>{r!==e&&r.classList.remove("no-hover")}),separators.forEach(e=>{e.classList.remove("no-hover")}),e.classList.remove("hover")})});const scrollerWrapper=document.querySelector(".collection-scroller-wrapper");scrollerWrapper.addEventListener("mouseenter",()=>{scrollerWrapper.classList.add("paused")}),scrollerWrapper.addEventListener("mouseleave",()=>{scrollerWrapper.classList.remove("paused")});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-expand-info-box"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var header = document.querySelector(".expanding-info-header");
    var content = document.querySelector(".expanding-info-content");

    header.addEventListener("click", function() {
      content.classList.toggle("show");
      header.classList.toggle("collapse");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-expanding-box-full"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var header = document.querySelector(".expanding-info-header");
    var content = document.querySelector(".expanding-info-content");

    header.addEventListener("click", function() {
      content.classList.toggle("show");
      header.classList.toggle("collapse");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-text-img-carousel"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded",function(){let e=document.querySelector(".finders-carousel .prev-arrow"),t=document.querySelector(".finders-carousel .next-arrow"),r=document.querySelector(".finders-carousel .carousel-images");e.addEventListener("click",function(e){e.preventDefault(),r.scrollBy({left:-r.offsetWidth,behavior:"smooth"})}),t.addEventListener("click",function(e){e.preventDefault(),r.scrollBy({left:r.offsetWidth,behavior:"smooth"})})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var videoUrl = '{{ section.settings.video_url }}'; // Get the video URL from Liquid

  if (videoUrl && videoUrl !== '') {
    var newsletterPopup = document.getElementById('NewsletterPopup-{{ section.id }}');
    if (newsletterPopup) {
      newsletterPopup.classList.add('modal_video');
    }
  }
});

  } catch(e) { console.error(e); }
})();
      })();
